<img [src]="brandLogo" style="width:80px;height:auto;display: inline-block;"/>
<button *ngFor="let link of routeLinks" [ngClass]="classesFor(link)" kendoButton [look]="'flat'" [routerLink]="linkFor(link)"><kendo-icon [name]="link.icon"></kendo-icon> {{link.label}}</button>
<div style="margin:0;">
  <button *ngFor="let link of accountRequiredLinks" [ngClass]="classesFor(link)" kendoButton [look]="'flat'" [routerLink]="linkFor(link)">{{link.label}}</button>
</div>
